import React, {Fragment, useEffect} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";

import CommonHeader from "../../components/Headers/CommonHeader";
import ProtectedContent from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import {requestEventFieldTypes} from "../../redux/Actions/eventRule.actions";
import {getEventFieldTypesList} from "../../redux/Selectors/eventRule.selector";
import EventRuleModal from "./eventRuleModal";
import EventRulesTable from "./eventRulesTable";

const EventRulesComponent = () => {
  const dispatch = useDispatch();
  const eventTypeOptions = useSelector(getEventFieldTypesList);

  const {
    isOpen: isEventRuleModalOpen,
    onOpen: openEventRuleModal,
    onClose: closeEventRuleModal,
  } = useDisclosure();

  useEffect(() => {
    if (isEmpty(eventTypeOptions)) {
      dispatch(requestEventFieldTypes());
    }
  }, [dispatch, eventTypeOptions]);

  return (
    <SafeView>
      <ProtectedContent perms={["view_eventrule"]} showFallback>
        <Fragment>
          {isEventRuleModalOpen && (
            <EventRuleModal open={isEventRuleModalOpen} onCancel={closeEventRuleModal} />
          )}
          <ProtectedContent perms={["add_eventrule"]}>
            <CommonHeader
              content="Add Event Rule"
              handleAddClick={openEventRuleModal}
              testID={"add_eventrule"}
            />
          </ProtectedContent>
          <EventRulesTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const EventRulesPage = () => {
  return (
    <PageURLContextProvider>
      <EventRulesComponent />
    </PageURLContextProvider>
  );
};

export default EventRulesPage;
